import { Skeleton } from 'primereact/skeleton';
import Container, {
	Column,
	FlexSpaceBetweenContainer,
	Row,
} from '../container/Container';
import Spacing from '../container/Spacing';

const LineChartSkeleton = () => {
	return (
		<Column>
			<Skeleton width="202px" height="24px" className="skeleton" />
			<Spacing height="h-2" />
			<Skeleton width="202px" height="54px" className="skeleton" />
			<Spacing height="h-7" />
			<Row>
				<Skeleton width="16px" height="278px" className="skeleton" />
				<Spacing width="w-[10px]" />
				<Column gap="gap-7">
					<Skeleton width="30px" height="16px" className="skeleton" />
					<Skeleton width="30px" height="16px" className="skeleton" />
					<Skeleton width="30px" height="16px" className="skeleton" />
					<Skeleton width="30px" height="16px" className="skeleton" />
					<Skeleton width="30px" height="16px" className="skeleton" />
					<Spacing width="w-[10px]" />
				</Column>
				<Spacing width="w-[11px]" />
				<Container className="self-end">
					<Column gap="gap-[100px]">
						<svg
							width="100%"
							height="86px"
							viewBox="0 0 536 86"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<title>line chart skeleton</title>
							<path
								d="M2.5 45L43.2648 82L116.641 35L198.681 42.5L278.682 3.5L358.173 42.5L443.27 35H535.5"
								stroke="#00000014"
								stroke-width="6"
							/>
						</svg>
						<FlexSpaceBetweenContainer className="self-end">
							<Skeleton
								width="36px"
								height="16px"
								className="skeleton"
							/>
							<Skeleton
								width="36px"
								height="16px"
								className="skeleton"
							/>
							<Skeleton
								width="36px"
								height="16px"
								className="skeleton"
							/>
							<Skeleton
								width="36px"
								height="16px"
								className="skeleton"
							/>
							<Skeleton
								width="36px"
								height="16px"
								className="skeleton"
							/>
							<Skeleton
								width="36px"
								height="16px"
								className="skeleton"
							/>
							<Skeleton
								width="36px"
								height="16px"
								className="skeleton"
							/>
						</FlexSpaceBetweenContainer>
					</Column>
				</Container>
			</Row>
		</Column>
	);
};

export default LineChartSkeleton;
